import CRUDFormComponent from '../../components/CRUDFormComponent'

const CommunesForm = () => {
  const fields = [{ key: 'name', label: 'Nombre', type: 'string' }]

  return (
    <>
      <CRUDFormComponent
        entityName={{ singular: 'Comuna' }}
        fields={fields}
        entityUrl="/communes"
      />
    </>
  )
}

export default CommunesForm
